import React, { useState } from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"
import Container from "../../partials/container"
import { color } from "../../../components/colors"
import SectionTitle from "../../atoms/section-title"
import WhiteBox from "../../atoms/white-box"
import ServicesBoxes from "../../organisms/services-boxes"
//import { Parallax, Background } from "react-parallax"

const Services = styled.section`
  width: 100%;
  position: relative;
  padding: 24px 0 16px;
  background-color: ${color.neutral40};

  @media (min-width: 769px) {
    padding: 90px 0;
  }
`

const HomepageServicesSection = ({ data }) => {
  return (
    <Services id="nasza-oferta">
      <Container>
        <SectionTitle
          title="Zakres usług"
          center
          mb="50"
          lineWidth="48px"
          lineCenter
          color={color.white}
          pb="64px"
        />
        <ServicesBoxes data={data} />
      </Container>
    </Services>
  )
}
export default HomepageServicesSection
